import React from 'react'
import SwiperItem from './item';
import styles from './index.module.scss'

function VideoSwiper ({list, paginationList, dot, play, next, prev, pause}) {
    const doNext = () => {
        next()
    }
    const doPrev = () => {
        prev()
    }
    const doDot = (index) => {
        dot(index)
    }
    const doPlay = (index) => {
        play(index)
    }
    const doPause = (index) => {
        pause(index)
    }
    return (
        <div className={`middle lx-relative ${styles.swiper}`}>
            <ul className="lx-relative">
                <SwiperItem list={ list } play={doPlay.bind(this)} pause={doPause.bind(this)}></SwiperItem>
                <div className="video-swiper-button-next lx-pointer" onClick={doNext.bind(this)}></div>
                <div className="video-swiper-button-prev lx-pointer" onClick={doPrev.bind(this)}></div>
            </ul>
            <div className="video-swiper-pagination lx-flex-row-center">
                {
                    paginationList.map((item, index) => {
                        return (
                            <div className={`video-dot lx-pointer ${item.isCurrent?'active':''}`} key={index} onClick={doDot.bind(this, index)}></div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default VideoSwiper;